<template>
  <div class="management_wrapper">
    <div class="header_title">
      <div
        v-for="(item, index) in titleList"
        :key="index"
        @click="toggleShow(index)"
        :class="index === showIndex ? 'active' : ''"
      >
        {{ item }}
      </div>
    </div>
    <!-- 企业 -->
    <template v-if="show">
      <div class="contianer">
        <div v-for="(item, index) in companyList" :key="index">
          <p class="p">{{ item.title }}</p>
          <span class="ipt">{{ item.content }}</span>
        </div>

        <div class="management_title">
          <p>企业</p>
          <span class="edit" @click="handleJump(0)">编辑</span>
        </div>
      </div>
    </template>

    <!-- 个人 -->
    <template v-if="!show">
      <div class="contianer">
        <div class="name" v-for="(item, index) in personList" :key="index">
          <p class="p">{{ item.title }}</p>
          <span class="ipt">{{ item.content }}</span>
        </div>
        <div class="title">
          <p>个人</p>
          <span class="edit" @click="handleJump(0)">编辑</span>
        </div>
      </div>
    </template>

    <div class="addPolicy">
      <van-button type="primary" class="addBtn" block @click="handleJump(1)"
        >添加常用投保人</van-button
      >
    </div>
  </div>
</template>

<script>
import "./PolicyHolderManagement.less";
import { Dialog } from "vant";
import { Button } from "vant";
import { getPolicyHolderManagement } from "../../api/api";

export default {
  name: "PolicyHolderManagement",
  data() {
    return {
      show: true,
      showIndex: 0, // 默认显示企业
      titleList: ["企业", "个人"],
      personList: [
        {
          title: "姓名",
          content: "张一",
        },
        {
          title: "证件类型",
          content: "身份证",
        },
        {
          title: "证件号码",
          content: "32128319921024386",
        },
        {
          title: "手机号",
          content: "18651806126",
        },
      ],
      companyList: [
        {
          title: "公司名称",
          content: "上海大黍保信息技术有限公司",
        },
        {
          title: "证件类型",
          content: "统一社会信用代码",
        },
        {
          title: "证件号码",
          content: "32128319921024386",
        },
        {
          title: "手机号",
          content: "18651806126",
        },
      ],
    };
  },
  async mounted() {
    const data = await getPolicyHolderManagement({
      id: 161,
    });
    console.log("data" + data);
  },
  components: {
    "van-button": Button,
  },
  methods: {
    toggleShow(index) {
      this.show = !this.show; // 切换企业和个人
      this.showIndex = index; // 切换类active
      console.log(this.showIndex);
    },

    handleJump(type) {
      // typy为0是编辑操作，值为1是新增常用投保人操作
      let query = {};
      let holderType = this.showIndex;
      if (type === 0) {
        query = {
          type, // 编辑操作
          holderType, // 投保人类型，0为企业，1为个人
          holderId: 2,
        };
      } else {
        query = {
          type, // 新增操作
          holderType, // 投保人类型，0为企业，1为个人
        };
      }
      this.$router.push({
        path: "/addManagement",
        query,
      });
    },
  },
};
</script>

